function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
// Imports
import React from 'react';
export var PanelContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(PanelContainer, _React$Component);

  var _super = _createSuper(PanelContainer);

  function PanelContainer() {
    _classCallCheck(this, PanelContainer);

    return _super.apply(this, arguments);
  }

  _createClass(PanelContainer, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "panel panel-default",
        id: this.props.id
      }, this.props.children);
    }
  }]);

  return PanelContainer;
}(React.Component);
export var PanelHeader = /*#__PURE__*/function (_React$Component2) {
  _inherits(PanelHeader, _React$Component2);

  var _super2 = _createSuper(PanelHeader);

  function PanelHeader() {
    _classCallCheck(this, PanelHeader);

    return _super2.apply(this, arguments);
  }

  _createClass(PanelHeader, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement("div", {
        className: "panel-heading",
        onClick: function onClick() {
          if (_this.props.handleClick) {
            _this.props.handleClick();
          }
        }
      }, this.props.children);
    }
  }]);

  return PanelHeader;
}(React.Component);
export var PanelBody = /*#__PURE__*/function (_React$Component3) {
  _inherits(PanelBody, _React$Component3);

  var _super3 = _createSuper(PanelBody);

  function PanelBody() {
    _classCallCheck(this, PanelBody);

    return _super3.apply(this, arguments);
  }

  _createClass(PanelBody, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "panel-body"
      }, this.props.children);
    }
  }]);

  return PanelBody;
}(React.Component);
export var PanelFooter = /*#__PURE__*/function (_React$Component4) {
  _inherits(PanelFooter, _React$Component4);

  var _super4 = _createSuper(PanelFooter);

  function PanelFooter() {
    _classCallCheck(this, PanelFooter);

    return _super4.apply(this, arguments);
  }

  _createClass(PanelFooter, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "panel-footer"
      }, this.props.children);
    }
  }]);

  return PanelFooter;
}(React.Component);
export default {
  Container: PanelContainer,
  Header: PanelHeader,
  Body: PanelBody,
  Footer: PanelFooter
};